export default "__VITE_ASSET__CClDncbV__"